import type * as core from '../../../../../../../core'

export const query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    '{}': {
      type: 'metric',
      overflowActions: {
        '[]': [
          {
            '{}': {
              name: 'Override Risk',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias:
                            'sr.subaward-details.widgets.override-risk-level-dialog',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
      override: {
        '@.': '!risk_override',
      },
      content: {
        '{}': {
          name: 'Override Risk Level',
          notice: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@.': '!risk_override',
                    },
                    null,
                  ],
                },
                {
                  '{}': {
                    style: 'warning',
                    description: 'Computed risk level is overridden.',
                  },
                },
              ],
              null,
            ],
          },
          event: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@.': '!risk_override',
                    },
                    null,
                  ],
                },
                {
                  '{}': {
                    time: '(TODO: overriden date)',
                  },
                },
              ],
              {
                '{}': {
                  time: {
                    if: [
                      [
                        {
                          or: [
                            {
                              '=': [
                                {
                                  '@': 'subawardSnapshot',
                                },
                                null,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@': 'subrecipient',
                                },
                                null,
                              ],
                            },
                          ],
                        },
                        null,
                      ],
                      {
                        '++': [
                          '(',
                          {
                            if: [
                              [
                                {
                                  '>': [
                                    {
                                      '@>': [
                                        {
                                          '@': 'subawardSnapshot',
                                        },
                                        'scoredDate',
                                      ],
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@': 'subrecipient',
                                        },
                                        'scoredDate',
                                      ],
                                    },
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scoredDate',
                                  ],
                                },
                              ],
                              {
                                '@>': [
                                  {
                                    '@': 'subrecipient',
                                  },
                                  'scoredDate',
                                ],
                              },
                            ],
                          },
                          ')',
                        ],
                      },
                    ],
                  },
                },
              },
            ],
          },
          value: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@.': '!risk_override',
                    },
                    null,
                  ],
                },
                {
                  '{}': {
                    emphasis: 'TODO: Overriden Level',
                  },
                },
                {
                  or: [
                    {
                      '=': [
                        {
                          '@': 'subawardSnapshot',
                        },
                        null,
                      ],
                    },
                    {
                      '=': [
                        {
                          '@': 'subrecipient',
                        },
                        null,
                      ],
                    },
                  ],
                },
                {
                  '{}': {
                    emphasis: '- ',
                    aside: '/ -',
                  },
                },
              ],
              {
                '{}': {
                  emphasis: {
                    if: [
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            45,
                          ],
                        },
                        'High',
                      ],
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            21,
                          ],
                        },
                        'Medium',
                      ],
                      'Low',
                    ],
                  },
                  quality: {
                    if: [
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            45,
                          ],
                        },
                        'bad',
                      ],
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            21,
                          ],
                        },
                        'neutral',
                      ],
                      'good',
                    ],
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
  subqueries: {
    subrecipient: {
      selection: {
        '@': 'subrecipientSnapshot',
      },
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!subrecip',
      },
      target: 'ent:!subrecips:!subrecip',
      subqueries: {
        subrecipientSnapshot: {
          ref: {
            attr: 'attr:snap#!subrecips#!subrecipient_risk_survey:!subj',
          },
          target: 'snap:!subrecips:!subrecipient_risk_survey',
          quantity: 1,
          selection: {
            '{}': {
              scoredDate: {
                '@.': '!when',
              },
              possible: {
                score: {
                  possible: '*',
                },
              },
              scored: {
                score: '*',
              },
            },
          },
        },
      },
    },
    subawardSnapshot: {
      ref: {
        attr: 'attr:snap#!subawards#!subaward_risk_survey:!subj',
      },
      target: 'snap:!subawards:!subaward_risk_survey',
      quantity: 1,
      selection: {
        '{}': {
          scoredDate: {
            '@.': '!when',
          },
          possible: {
            score: {
              possible: '*',
            },
          },
          scored: {
            score: '*',
          },
        },
      },
    },
  },
} as unknown as core.mosaic.Widget.Query
